// components
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";

// hooks
import useHttp from "hooks/use-http";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// mui cm
import { Button, Grid, Tooltip } from "@mui/material";

// styled cm
import {
  ButtonContainer,
  StyledDataText,
  StyledDataTitle,
  StyledGrid,
  StyledStack,
  StyledTitle,
} from "./UserInfo.style";

// mui icon
import LockResetIcon from "@mui/icons-material/LockReset";
import { getUserInfoRequest } from "api/requests";
import { Download } from "@mui/icons-material";
import { FILE_BASE_URL } from "constants";
import LoadingCM from "components/shared/Loading";
import { Fragment } from "react";
import spliter from "helper/digit-spliter";

export default function UserProfile() {
  const { loading, request } = useHttp(false);

  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });

    if (res) {
      setUserData(res.data);
    }
  }, []);

  useEffect(() => {
    getUserInfo();
  }, [getUserInfo]);

  return (
    <DrawerCM title="پنل دانش آموز" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          {/* <Grid item xs={12} my={3}>
            <BackButton />
          </Grid> */}
          <StyledStack>
            <StyledTitle>اطلاعات دانش آموز</StyledTitle>
            {userData ? (
              <Fragment>
                <Grid container>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>نام و نام خانوادگی</StyledDataTitle>
                    <StyledDataText>
                      {userData.first_name} {userData.last_name}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>نام پدر</StyledDataTitle>
                    <StyledDataText>{userData.father_name}</StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>کد ملی</StyledDataTitle>
                    <StyledDataText>{userData.national_code}</StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>شماره تماس</StyledDataTitle>
                    <StyledDataText>{userData.phone_number}</StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>شماره تماس پدر</StyledDataTitle>
                    <StyledDataText>
                      {userData.father_mobile_number ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>تاریخ تولد</StyledDataTitle>
                    <StyledDataText>
                      {userData.birth_date ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>مقطع تحصیلی</StyledDataTitle>
                    <StyledDataText>
                      {userData.section ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>پایه تحصیلی</StyledDataTitle>
                    <StyledDataText>
                      {userData.level ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>رشته تحصیلی</StyledDataTitle>
                    <StyledDataText>
                      {userData.field_of_study ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle> کد دانش آموزی</StyledDataTitle>
                    <StyledDataText>
                      {userData.student_code ?? "ثبت نشده"}
                    </StyledDataText>
                  </StyledGrid>
                  <StyledGrid item lg={4} md={6} xs={12}>
                    <StyledDataTitle>شهریه باقی ماند (ریال)</StyledDataTitle>
                    <StyledDataText>
                      {spliter(userData.remaining)}
                    </StyledDataText>
                  </StyledGrid>
                  <Grid item lg={4} md={6} xs={12}>
                    {userData.class_program && (
                      <Tooltip title="دانلود" followCursor placement="top">
                        <Button
                          fullWidth
                          sx={{ display: "flex", justifyContent: "start" }}
                          download
                          href={FILE_BASE_URL + userData.class_program}
                          target="_blank"
                          endIcon={<Download />}
                        >
                          دانلود برنامه کلاسی
                        </Button>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
                <ButtonContainer>
                  <Button
                    variant="contained"
                    endIcon={<LockResetIcon fontSize="large" />}
                    onClick={() => navigate("/get_otp")}
                  >
                    {" "}
                    ویرایش گذرواژه
                  </Button>
                </ButtonContainer>
              </Fragment>
            ) : (
              <StyledDataText>اطلاعات یافت نشد</StyledDataText>
            )}
          </StyledStack>
        </Fragment>
      )}
    </DrawerCM>
  );
}
